<ifc-base-dialog title="Email bank link"
                 [actions]="actions"
                 (actionClicked)="onActionClicked($event)">
  <ng-template #content>
    <p class="description">{{data.accountName}} has been approved for funding from {{data.companyName}}. Send bank link details to the merchant’s email below.
      We
      use <a href="https://plaid.com/"
         target="_blank">Plaid</a> to securely link bank accounts.</p>
    <form [formGroup]="form">
      <mat-form-field class="form-field"
                      appearance="outline">
        <mat-label>Email</mat-label>
        <input matInput
               formControlName="email"
               cdkFocusInitial
               type="text"
               [matAutocomplete]="auto">
        <mat-autocomplete #auto="matAutocomplete">
          <mat-option *ngFor="let option of filteredOptions"
                      [value]="option">
            <span>{{option}}</span>
          </mat-option>
        </mat-autocomplete>
        <mat-error>Please enter a valid email address.</mat-error>
      </mat-form-field>
    </form>
  </ng-template>
</ifc-base-dialog>
